import styled from "@emotion/styled";

export const ImpersonationModalViewRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 2rem;
`;

export const ImpersonationDescription = styled.p`
  line-height: 1.4rem;
`;
